import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const OfferDocuments = ({ documents }) =>
  Boolean(documents.length) && (
    <div className='max-width-div add-margin'>
      <div className='black-44'>Documents</div>
      <div className='docu-card-wrapper'>
        {documents.map(({ _id, title, url, previewImageUrl }) => (
          <div key={_id} className='docu-card-container'>
            <div
              className='card-docu-preview'
              style={
                previewImageUrl
                  ? {
                      backgroundImage: `url('${previewImageUrl}')`,
                      backgroundSize: 'cover',
                    }
                  : {}
              }
            />
            <div className='card-docu-title'>
              <div>{title}</div>
              <Link
                className='btn-download w-inline-block'
                target='_blank'
                to={url}
              >
                <div>View</div>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

OfferDocuments.propTypes = {
  documents: PropTypes.array.isRequired,
};

export default OfferDocuments;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferDocuments.js